// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, func-names
export default function ({ store, error }) {
	if (!store.state.authUser) {
		error({
			message: 'You are not authorized',
			statusCode: 403,
		})
	}
}
